export default [
  {
    path: '/admin/defines/Supplier-types',
    name: 'SupplierTypes',
    component: () => import('@/views/Admin/Defines/Supplier_types/Index.vue'),
    meta: {
      pageTitle: 'Tedarikçi Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/Supplier-types/add',
    name: 'SupplierTypeAdd',
    component: () => import('@/views/Admin/Defines/Supplier_types/Add.vue'),
    meta: {
      pageTitle: 'Tedarikçi Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/Supplier-types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/Supplier-types/edit/:id',
    name: 'SupplierTypeEdit',
    component: () => import('@/views/Admin/Defines/Supplier_types/Edit.vue'),
    meta: {
      pageTitle: 'Tedarikçi Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/Supplier-types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
